import Vue from 'vue'
import Vuex from 'vuex'
import axios from '@/api/index'

import Nprogress from 'nprogress';
import globalAxios from 'axios'

import router from '@/router/index'
import qs from 'qs'
Vue.use(Vuex)
const state = {
  tdsPaymentsList: [],
  paymentsDetails: [],
  chequePaymentsList: [],
  productsList: [],
  cashPaymentsDetails: [],
  bankDepositDetails: [],
  paymentCollectionDetails: [],
  paymentDetailList: [],
  adminLedgerDetails: [],
  PaymentCollectionUserList: [],
  paymentCofigurationDetails: [],
  collectionUserAreaDetails: [],
  collectionUserAreaTableDetails: [],
  collectionApprovalAreaDetails: [],
  collectionApprovalAreaTableDetails: [],
  collectionAreaDetails : [],
  areaSampleFilePath : '',
  collectionUserAdminDetails : [],
  collectionUserAdminTableDetails : [],
  collectionApprovalAdminDetails : [],
  collectionApprovalAdminTableDetails : [],
  buildingMasterDetails : [],
  paymentBlockedList: [],
  collectionUsers: [],
  collectionExpiredUsers: [],
  requestedUsers: [],
  balancedUsers: []
}

const mutations = {
  CLEAR_PAYMENT_COLLECTION_STATE() {
    state.tdsPaymentsList = [];
    state.paymentsDetails = [];
    state.chequePaymentsList = [];
    state.productsList = [];
    state.cashPaymentsDetails = [];
    state.bankDepositDetails = [];
    state.paymentCollectionDetails = [];
  },
  SET_BLOCKED_LIST(state, userData) {
    var tData = {};
    var parseData = userData.message;
    state.paymentBlockedList = [];
    if (parseData != null) {
        tData[userData.accountId + '-paymentBlockedList'] = parseData;
        state.paymentBlockedList = tData;
    }
},
  SET_TDS_PAYMENT_LIST(state, userData) {
    var tData = {};
    var parseData = JSON.parse(userData.message);
    state.tdsPaymentsList = new Array();
    if (parseData != null) {
      tData[userData.accountId + '-tdsList'] = parseData;
      state.tdsPaymentsList = tData;
    }
  },
  DELETE_TDS_PAYMENT_LIST(state, data) {
    var paymentIds = data.paymentIds;
    var accountId = data.accountId;
    if (Object.keys(state.tdsPaymentsList).length != 0) {
      for (var i = 0; i < paymentIds.length; i++) {
        var index = state.tdsPaymentsList[accountId + "-tdsList"].findIndex(tds => tds.Payment.id == paymentIds[i]);
        state.tdsPaymentsList[accountId + "-tdsList"].splice(index, 1)
      }
    }
  },
  CHANGE_TDS_CERTIFICATE(state, data) {
    var pid = data.paymentId;
    var tdsCer = data.tdsCer;
    var accountId = data.accountId;
    if (Object.keys(state.tdsPaymentsList).length != 0) {
      var index = state.tdsPaymentsList[accountId + "-tdsList"].findIndex(tds => tds.Payment.id == pid);
      if (index != '-1') {
        state.tdsPaymentsList[accountId + "-tdsList"][index].Payment.tds_certificate = tdsCer;
      }
    }
  },
  CHANGE_TDS_CERTIFICATE_NUMBER(state, data) {
    var pid = data.paymentId;
    var tdsCerNum = data.tdsCerNum;
    var accountId = data.accountId;
    if (Object.keys(state.tdsPaymentsList).length != 0) {
      var index = state.tdsPaymentsList[accountId + "-tdsList"].findIndex(tds => tds.Payment.id == pid);
      if (index != '-1') {
        state.tdsPaymentsList[accountId + "-tdsList"][index].Payment.tds_certificate_num = tdsCerNum;
      }
    }
  },
  CHANGE_TDS_CREATED_DATE(state, data) {
    var pid = data.paymentId;
    var date = data.date;
    var accountId = data.accountId;
    if (Object.keys(state.tdsPaymentsList).length != 0) {
      var index = state.tdsPaymentsList[accountId + "-tdsList"].findIndex(tds => tds.Payment.id == pid);
      if (index != '-1') {
        state.tdsPaymentsList[accountId + "-tdsList"][index].Payment.create_datetime = date;
      }
    }
  },
  SET_PAYMENT_DETAILS(state, userData) {
    var tData = {};
    var parseData = userData;
    state.paymentsDetails = new Array();
    if (parseData != null) {
      state.paymentsDetails = parseData;
    }
  },
  SET_CHEQUE_PAYMENT_LIST(state, userData) {
    var tData = {};
    var parseData = JSON.parse(userData.message);
    state.chequePaymentsList = new Array();
    if (parseData != null) {
      tData[userData.accountId + '-chequeList'] = parseData;
      state.chequePaymentsList = tData;
    }
  },
  SET_PRODUCT_LIST(state, data) {
    var tData = {};
    var parseData = data;
    state.productsList = new Array();
    if (parseData != null) {
      tData['productList'] = parseData;
      state.productsList = tData;
    }
  },
  REJECT_CHEQUE_PAYMENT(state, data) {
    var paymentIds = data.paymentId;
    var accountId = data.accountId;
    if (Object.keys(state.chequePaymentsList).length != 0) {
      for (var i = 0; i < paymentIds.length; i++) {
        var index = state.chequePaymentsList[accountId + "-chequeList"].findIndex(cheque => cheque.Payment.id == paymentIds[i]);
        state.chequePaymentsList[accountId + "-chequeList"].splice(index, 1)
      }
    }
  },
  SET_CASH_PAYMENT_LIST(state, data) {
    var tData = {};
    var parseData = data;
    state.cashPaymentsDetails = new Array();
    if (parseData != null) {
      tData['cashList'] = parseData;
      state.cashPaymentsDetails = tData;
    }
  },
  SET_BANK_DEPOSIT_LIST(state, data) {
    var tData = {};
    var parseData = JSON.parse(data.message);
    state.bankDepositDetails = new Array();
    if (parseData != null) {
      tData['bankDepositList'] = parseData;
      state.bankDepositDetails = tData;
    }
  },
  SET_PAYMENT_COLLECTION_LIST(state, data) {
    var tData = {};
    var parseData = data.message;
    state.paymentCollectionDetails = new Array();
    if (parseData != null) {
      tData['paymentCollectionDetail'] = parseData;
      state.paymentCollectionDetails = tData;
    }
  },
  SET_ADMIN_LEDGER_LIST(state, data) {
    var tData = {};
    var parseData = data.message;
    state.adminLedgerDetails = new Array();
    if (parseData != null) {
      tData['adminLedger'] = parseData;
      state.adminLedgerDetails = tData;
    }
  },
  SET_PAYMENT_COLLECTION_USER_LIST(state, userData) {
    var tData = {};
    var parseData = JSON.parse(userData.message);
    state.PaymentCollectionUserList = new Array();
    if (parseData != null) {
      tData[userData.accountId + '-paymentCollectionList'] = parseData;
      state.PaymentCollectionUserList = tData;
    }
  },
  ASSIGN_ADMIN(state, data) {
    var uIds = data.userId;
    var accountId = data.accountId;
    if (Object.keys(state.PaymentCollectionUserList).length != 0) {
      for (var i = 0; i < uIds.length; i++) {
        var index = state.PaymentCollectionUserList[accountId + "-paymentCollectionList"].findIndex(pay => pay.User.id == uIds[i]);
        state.PaymentCollectionUserList[accountId + "-paymentCollectionList"][index].User.admin_name = data.adminName;
      }
    }
  },
  DELETE_PAYMENT_COLLECTION_LIST(state, data) {
    var userIds = data.userIds;
    var accountId = data.accountId;
    if (Object.keys(state.PaymentCollectionUserList).length != 0) {
      for (var i = 0; i < userIds.length; i++) {
        var index = state.PaymentCollectionUserList[accountId + "-paymentCollectionList"].findIndex(pay => pay.User.id == userIds[i]);
        state.PaymentCollectionUserList[accountId + "-paymentCollectionList"].splice(index, 1)
      }
    }
  },
  SET_PAYMENT_CONFIGURATION_LIST(state, data) {
    var tData = {};
    var parseData = data.message;
    state.paymentCofigurationDetails = new Array();
    if (parseData != null) {
      tData['configurationList'] = parseData;
      state.paymentCofigurationDetails = tData;
    }
  },
  SET_COLLECTION_USER_AREA_LIST(state, data) {
    var tData = {};
    var parseData = data.message;
    state.collectionUserAreaDetails = new Array();
    if (parseData != null) {
      tData['collectionUserAreaList'] = parseData;
      state.collectionUserAreaDetails = tData;
    }
  },
  SET_COLLECTION_USER_AREA_TABLE_LIST(state, data) {
    var tData = {};
    var parseData = JSON.parse(data.message);
    state.collectionUserAreaTableDetails = new Array();
    if (parseData != null) {
      tData['collectionUserAreaTableList'] = parseData;
      state.collectionUserAreaTableDetails = tData;
    }
  },
  SET_COLLECTION_APPROVAL_AREA_LIST(state, data) {
    var tData = {};
    var parseData = data.message;
    state.collectionApprovalAreaDetails = new Array();
    if (parseData != null) {
      tData['collectionApprovalAreaList'] = parseData;
      state.collectionApprovalAreaDetails = tData;
    }
  },
  SET_COLLECTION_APPROVAL_AREA_TABLE_LIST(state, data) {
    var tData = {};
    var parseData = JSON.parse(data.message);
    state.collectionApprovalAreaTableDetails = new Array();
    if (parseData != null) {
      tData['collectionApprovalAreaTableList'] = parseData;
      state.collectionApprovalAreaTableDetails = tData;
    }
  },
  APPROVE_COLLECTION_LIST(state, data) {
    var userIds = data.userIds;

    if (Object.keys(state.collectionApprovalAreaTableDetails).length != 0) {
      var index = state.collectionApprovalAreaTableDetails["collectionApprovalAreaTableList"].findIndex(pay => pay.PaymentCollectionMode.id == userIds);
      state.collectionApprovalAreaTableDetails["collectionApprovalAreaTableList"].splice(index, 1)
    }
    if (Object.keys(state.collectionApprovalAdminTableDetails).length != 0) {
      var index = state.collectionApprovalAdminTableDetails["collectionApprovalAdminTableList"].findIndex(pay => pay.PaymentCollectionMode.id == userIds);
      state.collectionApprovalAdminTableDetails["collectionApprovalAdminTableList"].splice(index, 1)
    }
  },
  APPROVE_ALL_COLLECTION_LIST(state, data) {
    var userIds = data.userIds;

    if (Object.keys(state.collectionApprovalAreaTableDetails).length != 0) {
      for (var i = 0; i < userIds.length; i++) {
        var index = state.collectionApprovalAreaTableDetails["collectionApprovalAreaTableList"].findIndex(pay => pay.PaymentCollectionMode.id == userIds[i]);
        state.collectionApprovalAreaTableDetails["collectionApprovalAreaTableList"].splice(index, 1)
      }
    }
    if (Object.keys(state.collectionApprovalAdminTableDetails).length != 0) {
      for (var i = 0; i < userIds.length; i++) {
        var index = state.collectionApprovalAdminTableDetails["collectionApprovalAdminTableList"].findIndex(pay => pay.PaymentCollectionMode.id == userIds[i]);
        state.collectionApprovalAdminTableDetails["collectionApprovalAdminTableList"].splice(index, 1)
      }
    }
  },
  SET_COLLECTION_AREA_LIST(state, data) {
    var tData = {};
    var parseData = data.message;
    state.collectionAreaDetails = new Array();
    state.areaSampleFilePath = parseData.samplePath;
    if (parseData != null) {
      tData['areaList'] = parseData;
      state.collectionAreaDetails = tData;
    }
  },
  DETETE_COLLECTION_AREA(state, data) {
    var userIds = data.userIds;

    if (Object.keys(state.collectionAreaDetails).length != 0) {
      var index = state.collectionAreaDetails["areaList"].areas.findIndex(area => area.CollectionArea.id == userIds);
      state.collectionAreaDetails["areaList"].areas.splice(index, 1)
    }
  },
  DETETE_COLLECTION_STREET(state, data) {
    var userIds = data.userIds;
    var areaId = data.areaId;
    console.log("data is",data);
    console.log("hey",userIds);
    console.log("area",areaId);
    console.log("array",state.collectionAreaDetails["areaList"].streets);
    var temp =JSON.parse(state.collectionAreaDetails["areaList"].streets);
    console.log("temp",temp);
    console.log("collectionAreaDetails",state.collectionAreaDetails);

    if (Object.keys(state.collectionAreaDetails).length != 0) {
      //var index = state.collectionAreaDetails["areaList"].streets[areaId].findIndex(street => street.CollectionStreet.id == userIds);
      var index=temp[areaId].findIndex(street=>street.CollectionStreet.id == userIds);
      if(index != -1){
        temp[areaId].splice(index, 1);
       }
      state.collectionAreaDetails["areaList"].streets=JSON.stringify(temp);
    }
  },
  DETETE_COLLECTION_BLOCK(state, data) {
    var userIds = data.userIds;
    var streetId = data.streetId;
    console.log("data is",data);
    console.log("hey",userIds);
    console.log("hey2",streetId);
    console.log("array",state.collectionAreaDetails["areaList"].blocks);
    var temp =JSON.parse(state.collectionAreaDetails["areaList"].blocks);
    console.log("temp",temp);
    console.log("collectionAreaDetails",state.collectionAreaDetails);
    if (Object.keys(state.collectionAreaDetails).length != 0) {
      for (var i = 0; i < userIds.length; i++) { 
      //console.log("qwertyui",state.collectionAreaDetails["areaList"].blocks['street_id']);
       // var index = state.collectionAreaDetails["areaList"].blocks[streetId].findIndex(block => block.CollectionBlock.id == userIds);
       //var streetindex=state.collectionAreaDetails["areaList"].findIndex(e=>e.blocks["street_id"]==streetId);
       //console.log("streetindex",streetindex);
        var index = temp[streetId].findIndex(block => block.CollectionBlock.id == userIds[i]);
       // console.log("array1",state.collectionAreaDetails.areaList.blocks[streetId]);
       if(index != -1){
       temp[streetId].splice(index, 1);
      }
       state.collectionAreaDetails["areaList"].blocks = JSON.stringify(temp);
      //  state.collectionAreaDetails["areaList"].blocks[streetId].splice(index, 1);
      }
    }

  },
  SET_COLLECTION_USER_ADMIN_LIST(state, data) {
    var tData = {};
    var parseData = data.message;
    state.collectionUserAdminDetails = new Array();
    if (parseData != null) {
      tData['collectionUserAdminList'] = parseData;
      state.collectionUserAdminDetails = tData;
    }
  },
  SET_COLLECTION_USER_ADMIN_TABLE_LIST(state, data) {
    var tData = {};
    var parseData = JSON.parse(data.message);
    state.collectionUserAdminTableDetails = new Array();
    if (parseData != null) {
      tData['collectionUserAdminTableList'] = parseData;
      state.collectionUserAdminTableDetails = tData;
    }
  },
  PAYMENT_COLLECTION_ADMIN_COLLECT(state, data) {
    var userIds = data.userIds;

    if (Object.keys(state.collectionUserAdminTableDetails).length != 0) {
      var index = state.collectionUserAdminTableDetails["collectionUserAdminTableList"].findIndex(collect => collect.j_contact.user_id == userIds);
      state.collectionUserAdminTableDetails["collectionUserAdminTableList"].splice(index, 1)
    }
  },
  SET_COLLECTION_APPROVAL_ADMIN_LIST(state, data) {
    var tData = {};
    var parseData = data.message;
    state.collectionApprovalAdminDetails = new Array();
    if (parseData != null) {
      tData['collectionApprovalAdminList'] = parseData;
      state.collectionApprovalAdminDetails = tData;
    }
  },
  SET_COLLECTION_APPROVAL_ADMIN_TABLE_LIST(state, data) {
    var tData = {};
    var parseData = JSON.parse(data.message);
    state.collectionApprovalAdminTableDetails = new Array();
    if (parseData != null) {
      tData['collectionApprovalAdminTableList'] = parseData;
      state.collectionApprovalAdminTableDetails = tData;
    }
  },
  SET_BUILDING_MASTER_LIST(state, data) {
    var tData = {};
    var parseData = data.message;
    state.buildingMasterDetails = new Array();
    if (parseData != null) {
      tData['buildingMasterList'] = parseData;
      state.buildingMasterDetails = tData;
    }
  },
  SET_PAYMENT_USERS(state, paymentstatus) {
    state.collectionUsers = paymentstatus.collectionUsers,
    state.requestedUsers = paymentstatus.requestedUsers,
    state.collectionExpiredUsers = paymentstatus.collectionExpiredUsers,
    state.balancedUsers = paymentstatus.balancedUsers
  },
  UPDATE_PREFERRED_TIME(state,data){
    var userId = data.userId;
    var accountId = data.accountId;
    if (Object.keys(state.PaymentCollectionUserList).length != 0) {
        var index = state.PaymentCollectionUserList[accountId + "-paymentCollectionList"].findIndex(user => user.User.id == userId);
        if (index != -1) {
          state.PaymentCollectionUserList[accountId + "-paymentCollectionList"][index].UserSetting1.value=data.preferredDate+","+data.fromTime+","+data.toTime;
        }   
    }
},
}

const actions = {
  getPaymentBlockedDetails({
      commit,
      dispatch
      }, authData) {
      Nprogress.start()
      return new Promise((resolve, reject) => {
          axios.get('/payment/blocked/true')
          .then(res => {
              Nprogress.done()
              commit('SET_BLOCKED_LIST', res.data)
              resolve(res.data);
          })
          .catch(error => console.log(error))
      });
  },
  payNowSubmit({
    commit,
    dispatch
  }, postData) {
    Nprogress.start()
    return new Promise((resolve, reject) => {
      axios.post('/payment/pay_now_link', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(res => {
          console.log("Response : ",res);
          Nprogress.done()
          resolve(res.data);
        })
        .catch(error => console.log(error))
    });
  },
  clearPaymentCollectionState({
    commit,
    dispatch
  }) {
    commit('CLEAR_PAYMENT_COLLECTION_STATE')
  },
  fetchTdsPaymentsList({
    commit,
    dispatch
  }, postData) {
    Nprogress.start()
    return new Promise((resolve, reject) => {
      axios.post('/billing/get_all_tds_payments', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(res => {
          Nprogress.done()
          if (res.data.status == "redirect") {
            router.push("/dashboard");
          } else {
            if (postData.export == true) {
              if (res.data.status != "success") {
                reject(res.data.message);
                return;
              }
              window.open("/backend" + res.data.message, "_blank");
              window.focus();
              return;
            }
            commit('SET_TDS_PAYMENT_LIST', res.data)
            resolve(res.data);
          }
        })
        .catch(error => console.log(error))
    });
  },
  deleteTdsPaymentSubmit({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {

      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/billing/delete_billing_payment', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()

          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          var successData = {
            paymentIds: response.data.paymentIds,
            accountId: postData.accountId
          }

          commit('DELETE_TDS_PAYMENT_LIST', successData);
          resolve(response.data);
        })
        .catch(error => console.log(error))
    });
  },
  tdsCertificateEdit({
    commit,
    dispatch
  }, postData) {

    return new Promise((resolve, reject) => {

      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/billing/change_tds_certificate', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          if (response.data.status == 'success') {
            var successData = {
              tdsCer: postData.value,
              accountId: postData.name,
              paymentId: postData.pk
            }
            commit('CHANGE_TDS_CERTIFICATE', successData);
            resolve(response.data);
          }
        })
        .catch(error => console.log(error));
    });
  },
  tdsCertificateNumEdit({
    commit,
    dispatch
  }, postData) {

    return new Promise((resolve, reject) => {

      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/billing/change_tds_certificate_number', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          if (response.data.status == 'success') {
            var successData = {
              tdsCerNum: postData.value,
              accountId: postData.name,
              paymentId: postData.pk
            }
            commit('CHANGE_TDS_CERTIFICATE_NUMBER', successData);
            resolve(response.data);
          }
        })
        .catch(error => console.log(error));
    });
  },
  tdsCreatedDateEdit({
    commit,
    dispatch
  }, postData) {

    return new Promise((resolve, reject) => {

      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/billing/edit_payment_created_date', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          if (response.data.status == 'success') {
            var successData = {
              date: postData.value,
              accountId: postData.name,
              paymentId: postData.pk
            }
            commit('CHANGE_TDS_CREATED_DATE', successData);
            resolve(response.data);
          }
        })
        .catch(error => console.log(error));
    });
  },
  getTdsPaymentDetails({
    commit,
    dispatch
  }, postData) {
    Nprogress.start()
    return new Promise((resolve, reject) => {
      axios.post('/billing/getPaymentDetails', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(res => {
          Nprogress.done()
          commit('SET_PAYMENT_DETAILS', res.data)
          resolve(res.data);
        })
        .catch(error => console.log(error))
    });
  },
  fetchChequePaymentsList({
    commit,
    dispatch
  }, postData) {
    Nprogress.start()
    return new Promise((resolve, reject) => {
      axios.post('/billing/get_all_cheque_payments', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(res => {
          Nprogress.done()
          if (res.data.status == "redirect") {
            router.push("/dashboard");
          } else {
            if (postData.export == true) {
              if (res.data.status != "success") {
                reject(res.data.message);
                return;
              }
              window.open("/backend" + res.data.message, "_blank");
              window.focus();
              return;
            }
          commit('SET_CHEQUE_PAYMENT_LIST', res.data)
          resolve(res.data);
          }
        })
        .catch(error => console.log(error))
    });
  },
  fetchProductList({
    commit,
    dispatch
  }, postData) {
    Nprogress.start()
    return new Promise((resolve, reject) => {
      axios.post('/billing/getProductBasedOnAccountId/' + postData.accountId, qs.stringify(postData, {
        parseArrays: false
      }))
        .then(res => {
          Nprogress.done()
          commit('SET_PRODUCT_LIST', res.data)
          resolve(res.data);
        })
        .catch(error => console.log(error))
    });
  },
  rejectCheckPaymentList({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {

      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/billing/reject_cheque_payment', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          if (response.data.status == 'success') {
            var successData = {
              accountId: postData.accountId,
              paymentId: postData.paymentId,
            }
            commit('REJECT_CHEQUE_PAYMENT', successData);
            resolve(response);
          }
        })
        .catch(error => console.log(error))
    });
  },
  fetchCashPaymentsList({
    commit,
    dispatch
  }) {
    Nprogress.start()
    return new Promise((resolve, reject) => {
      axios.post('/billing/cash_payments/null/true')
        .then(res => {
          Nprogress.done()
          if (res.data.status == "redirect") {
            router.push("/dashboard");
          } else {
          commit('SET_CASH_PAYMENT_LIST', res.data)
          resolve(res.data);
          }
        })
        .catch(error => console.log(error))
    });
  },
  fetchCollectCashChequeAdminsList({
    commit,
    dispatch
  }, postData) {
    Nprogress.start()
    return new Promise((resolve, reject) => {
      axios.post('/billing/get_payment_cash_details', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(res => {
          Nprogress.done()
          resolve(res.data);
        })
        .catch(error => console.log(error))
    });
  },
  getDepositPaymentDetails({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/billing/amount_deposit_in_bank_payments', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(res => {
          loader.hide()
          resolve(res.data);
        })
        .catch(error => console.log(error))
    });
  },
  submitDepositPaymentDetails({
    commit,
    dispatch
  }, postData) {
    Nprogress.start()
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/billing/amount_deposit_in_bank_admin', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(res => {
          Nprogress.done()
          loader.hide()
          resolve(res);

        })
        .catch(error => console.log(error))
    });
  },
  submitCollectPaymentDetails({
    commit,
    dispatch
  }, postData) {
    Nprogress.start()
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/billing/cash_collect_from_admin', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(res => {
          Nprogress.done()
          loader.hide()
          resolve(res);

        })
        .catch(error => console.log(error))
    });
  },
  fetchBankDepositList({
    commit,
    dispatch
  }, postData) {
    Nprogress.start()
    return new Promise((resolve, reject) => {
      axios.post('/billing/get_bank_deposits', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(res => {
          Nprogress.done()
          if (postData.export == true) {
            if (res.data.status != "success") {
              reject(res.data.message);
              return;
            }
            window.open("/backend" + res.data.message, "_blank");
            window.focus();
            return;
          }
          commit('SET_BANK_DEPOSIT_LIST', res.data)
          resolve(res.data);
        })
        .catch(error => console.log(error))
    });
  },
  getPaymentProcessAdminDetails({
    commit,
    dispatch
  }, postData) {
    Nprogress.start()
    return new Promise((resolve, reject) => {
      axios.post('/billing/get_payment_process_admin_details', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(res => {
          Nprogress.done()
          resolve(res.data);

        })
        .catch(error => console.log(error))
    });
  },
  getCashProcessFlowDetails({
    commit,
    dispatch
  }, postData) {
    Nprogress.start()
    return new Promise((resolve, reject) => {
      axios.post('/billing/get_payment_process_flow', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(res => {
          Nprogress.done()
          resolve(res.data);

        })
        .catch(error => console.log(error))
    });
  },
  fetchPaymentCollectionDetails({
    commit,
    dispatch
  }, postData) {
    Nprogress.start()
    return new Promise((resolve, reject) => {
      axios.get('/billing/payment_collection_details/' + postData.adminId + '/null/true')
        .then(res => {
          Nprogress.done()
          commit('SET_PAYMENT_COLLECTION_LIST', res.data)
          resolve(res.data);
        })
        .catch(error => console.log(error))
    });
  },
  fetchPaymentsCollList({
    commit,
    dispatch
  }, postData) {
    Nprogress.start()
    return new Promise((resolve, reject) => {
      axios.post('/billing/get_payment_collection_details', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(res => {
          Nprogress.done()
          resolve(res.data);
        })
        .catch(error => console.log(error))
    });
  },
  getCashMethodChangeDetails({
    commit,
    dispatch
  }, postData) {
    Nprogress.start()
    return new Promise((resolve, reject) => {
      axios.post('/billing/check_mode_of_payment_change', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(res => {
          Nprogress.done()
          resolve(res.data);

        })
        .catch(error => console.log(error))
    });
  },
  submitChangePaymentDetails({
    commit,
    dispatch
  }, postData) {

    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/billing/change_payment_method_collection', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(res => {
          loader.hide();
          resolve(res);
        })
        .catch(error => console.log(error))
    });
  },
  collectPaymentSubmit({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {

      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/billing/collect_cash_for_payment', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          resolve(response.data);
        })
        .catch(error => console.log(error))
    });
  },
  fetchAdminLedgerList({
    commit,
    dispatch
  }, postData) {
    Nprogress.start()
    return new Promise((resolve, reject) => {
      axios.get('/billing/admin_ledger/' + postData.adminId + '/' + postData.from + '/' + postData.to + '/true')
        .then(res => {
          Nprogress.done()
          state.adminLedgerDetails = new Array();
          commit('SET_ADMIN_LEDGER_LIST', res.data)
          resolve(res.data);
        })
        .catch(error => console.log(error))
    });
  },
  fetchPaymentCollectionList({
    commit,
    dispatch
  }, postData) {
    Nprogress.start()
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
          canCancel: false,
      });
      axios.post('/billing/user_billing_payment_data', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(res => {
          loader.hide();
          if (res.data.status == "redirect") {
            router.push("/dashboard");
          }else if(res.data.status=="error" && res.data.isDatabaseAccessibleCheck=="yes"){
            resolve(res.data);
          } else {
            if (postData.export == true) {
              if (res.data.status != "success") {
                reject(res.data.message);
                return;
              }
              window.open("/backend" + res.data.message, "_blank");
              window.focus();
              return;
            }
            commit('SET_PAYMENT_COLLECTION_USER_LIST', res.data)
            resolve(res.data);
          }
        })
        .catch(error => console.log(error))
    });
  },
  paymentAssignAdminModalSubmit({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {

      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/payments_collection/collection_assign_to_admin', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          if (response.data.status == 'success') {
            var successData = {
              userId: postData.userIds,
              accountId: postData.accountId,
              adminName: postData.adminName
            }
            if(postData.type == 'collectionAdminWise'){

            } else {
              commit('ASSIGN_ADMIN', successData);
            }
            
            resolve(response);
          }
        })
        .catch(error => console.log(error));
    });
  },
  paymentCollectionFetch({
    commit,
    dispatch
  }, postData) {
    Nprogress.start()
    return new Promise((resolve, reject) => {
      axios.post('/billing/getpaymentCollectionDetails', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(res => {
          Nprogress.done()
          resolve(res.data);
        })
        .catch(error => console.log(error))
    });
  },
  deletePaymentCollectionSubmit({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {

      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/billing/delete_payment_collection', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()

          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          var successData = {
            userIds: postData.userIds,
            accountId: postData.accountId
          }

          commit('DELETE_PAYMENT_COLLECTION_LIST', successData);
          resolve(response.data);
        })
        .catch(error => console.log(error))
    });
  },
  fetchPaymentConfigurationList({
    commit,
    dispatch
  }, postData) {
    if (postData == 'true') {
      Nprogress.start()
    }
    return new Promise((resolve, reject) => {
      axios.get('/payments_collection/configuration/true')
        .then(res => {
          if (postData == 'true') {
            Nprogress.done()
          }
          commit('SET_PAYMENT_CONFIGURATION_LIST', res.data)
          resolve(res.data);
        })
        .catch(error => console.log(error))
    });
  },
  addAdminAreaSubmit({
    commit,
    dispatch
  }, postData) {
    Nprogress.start()
    return new Promise((resolve, reject) => {
      axios.post('/payments_collection/add_admin_to_area', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(res => {
          Nprogress.done()
          if (res.data.status != 'success') {
            reject(res.data.message);
            return;
          }
          resolve(res.data);
        })
        .catch(error => console.log(error))
    });
  },
  removeAdminAreaSubmit({
    commit,
    dispatch
  }, postData) {
    Nprogress.start()
    return new Promise((resolve, reject) => {
      axios.post('/payments_collection/del_admin_from_area', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(res => {
          Nprogress.done()
          if (res.data.status != 'success') {
            reject(res.data.message);
            return;
          }
          resolve(res.data);
        })
        .catch(error => console.log(error))
    });
  },
  fetchCollectionUserAreaList({
    commit,
    dispatch
  }) {
    Nprogress.start()
    return new Promise((resolve, reject) => {
      axios.post('/payments_collection/collection_users/true')
        .then(res => {
          Nprogress.done()
          commit('SET_COLLECTION_USER_AREA_LIST', res.data)
          resolve(res.data);
        })
        .catch(error => console.log(error))
    });
  },
  fetchCollectionUserAreaTableList({
    commit,
    dispatch
  }, postData) {
    Nprogress.start()
    return new Promise((resolve, reject) => {
      axios.post('/payments_collection/get_all_collection_users', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(res => {
          Nprogress.done()
          if (res.data.status == "redirect") {
            router.push("/dashboard");
          } else {
          commit('SET_COLLECTION_USER_AREA_TABLE_LIST', res.data)
          resolve(res.data);
          }
        })
        .catch(error => console.log(error))
    });
  },
  paymentCollectionModalSubmit({
    commit,
    dispatch
  }, postData) {
    Nprogress.start()
    return new Promise((resolve, reject) => {
      axios.post('/payments_collection/collection_payment_method', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(res => {
          Nprogress.done()
          if (res.data.status != 'success') {
            resolve(res.data);
            return;
          }
          resolve(res.data);
        })
        .catch(error => console.log(error))
    });
  },
  fetchCollectionApprovalAreaList({
    commit,
    dispatch
  }) {
    Nprogress.start()
    return new Promise((resolve, reject) => {
      axios.post('/payments_collection/collection_approval/true')
        .then(res => {
          Nprogress.done()
          commit('SET_COLLECTION_APPROVAL_AREA_LIST', res.data)
          resolve(res.data);
        })
        .catch(error => console.log(error))
    });
  },
  fetchCollectionApprovalAreaTableList({
    commit,
    dispatch
  }, postData) {
    Nprogress.start()
    return new Promise((resolve, reject) => {
      axios.post('/payments_collection/get_all_collection_approvals', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(res => {
          Nprogress.done()
          if (res.data.status == "redirect") {
            router.push("/dashboard");
          } else {
          commit('SET_COLLECTION_APPROVAL_AREA_TABLE_LIST', res.data)
          resolve(res.data);
          }
        })
        .catch(error => console.log(error))
    });
  },
  approvePaymentCollectionSubmit({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {

      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/payments_collection/collection_approval_submit', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()

          if (response.data.status != 'success') {
            resolve(response.data);
            return;
          }
          var successData = {
            userIds: postData.modeId,
          }

          commit('APPROVE_COLLECTION_LIST', successData);
          resolve(response.data);
        })
        .catch(error => console.log(error))
    });
  },
  disapprovePaymentCollectionSubmit({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {

      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/payments_collection/collection_disapproval_submit', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()

          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          var successData = {
            userIds: postData.modeId,
          }

          commit('APPROVE_COLLECTION_LIST', successData);
          resolve(response.data);
        })
        .catch(error => console.log(error))
    });
  },
  approveAllPaymentCollectionSubmit({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {

      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/payments_collection/collect_all_payment_approval', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()

          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          var successData = {
            userIds: postData.userIds,
          }

          commit('APPROVE_ALL_COLLECTION_LIST', successData);
          resolve(response.data);
        })
        .catch(error => console.log(error))
    });
  },
  disapproveAllPaymentCollectionSubmit({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {

      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/payments_collection/collect_all_payment_disapproval', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()

          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          var successData = {
            userIds: postData.userIds,
          }

          commit('APPROVE_ALL_COLLECTION_LIST', successData);
          resolve(response.data);
        })
        .catch(error => console.log(error))
    });
  },
  fetchCollectionAreaList({
    commit,
    dispatch
  }) {
    Nprogress.start()
    return new Promise((resolve, reject) => {
      axios.get('/payments_collection/areas/true')
        .then(res => {
          Nprogress.done()
          commit('SET_COLLECTION_AREA_LIST', res.data)
          resolve(res.data);
        })
        .catch(error => console.log(error))
    });
  },
  submitAddEditAreaDetails({
    commit,
    dispatch
  },postData) {
    Nprogress.start()
    return new Promise((resolve, reject) => {
      
      axios.post('/payments_collection/create_area', qs.stringify(postData, {
        parseArrays: false
      }))
      .then(res => {
        Nprogress.done()
        if(res.data.status != 'success') {
          reject(res.data.message);
          return;
        }
        resolve(res);
      })
      .catch(error => console.log(error))
    });
  },
  submitDeleteAreaDetails({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {

      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/payments_collection/delete_area', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()

          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          var successData = {
            userIds: postData.areaId,
          }

          commit('DETETE_COLLECTION_AREA', successData);
          resolve(response);
        })
        .catch(error => console.log(error))
    });
  },
  submitAddEditStreetDetails({
    commit,
    dispatch
  },postData) {
    Nprogress.start()
    return new Promise((resolve, reject) => {
      
      axios.post('/payments_collection/create_street', qs.stringify(postData, {
        parseArrays: false
      }))
      .then(res => {
        Nprogress.done()
        if(res.data.status != 'success') {
          reject(res.data.message);
          return;
        }
        resolve(res);
      })
      .catch(error => console.log(error))
    });
  },
  submitDeleteStreetDetails({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {

      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/payments_collection/delete_Street', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()

          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          var successData = {
            userIds: postData.streetId,
            areaId: postData.areaId,
          }

          commit('DETETE_COLLECTION_STREET', successData);
          resolve(response);
        })
        .catch(error => console.log(error))
    });
  },
  submitAddEditBlockDetails({
    commit,
    dispatch
  },postData) {
    Nprogress.start()
    return new Promise((resolve, reject) => {
      
      axios.post('/payments_collection/create_block', qs.stringify(postData, {
        parseArrays: false
      }))
      .then(res => {
        Nprogress.done()
        if(res.data.status != 'success') {
          reject(res.data.message);
          return;
        }
        resolve(res);
      })
      .catch(error => console.log(error))
    });
  },
  submitDeleteBlockDetails({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {

      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/payments_collection/delete_block', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()

          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          var successData = {
            userIds: postData.blockId,
            streetId: postData.streetId,
          }

          commit('DETETE_COLLECTION_BLOCK', successData);
          resolve(response);
        })
        .catch(error => console.log(error))
    });
  },
  areaExportCsv({
    commit,
    dispatch
  }) {
    Nprogress.start()
    return new Promise((resolve, reject) => {
      axios.post('/payments_collection/export_areas_csv')
        .then(res => {
          Nprogress.done()
          resolve(res.data);

        })
        .catch(error => console.log(error))
    });
  },
  importAreaModal({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {

      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/payments_collection/import_areas_file', postData)
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  fetchCollectionUserAdminList({
    commit,
    dispatch
  }) {
    Nprogress.start()
    return new Promise((resolve, reject) => {
      axios.post('/payments_collection/collection_admin_users/true')
        .then(res => {
          Nprogress.done()
          commit('SET_COLLECTION_USER_ADMIN_LIST', res.data)
          resolve(res.data);
        })
        .catch(error => console.log(error))
    });
  },
  fetchCollectionUserAdminTableList({
    commit,
    dispatch
  }, postData) {
    Nprogress.start()
    return new Promise((resolve, reject) => {
      axios.post('/payments_collection/get_all_collection_admin_users', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(res => {
          Nprogress.done()
          if (res.data.status == "redirect") {
            router.push("/dashboard");
          } else {
            if (postData.export == true) {
              if (res.data.status != "success") {
                reject(res.data.message);
                return;
              }
              window.open("/backend" + res.data.message, "_blank");
              window.focus();
              return;
            }
            commit('SET_COLLECTION_USER_ADMIN_TABLE_LIST', res.data)
            resolve(res.data);
          }
        })
        .catch(error => console.log(error))
    });
  },
  paymentCollectionAdminModalSubmit({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/payments_collection/collection_payment_method', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(res => {
          loader.hide()

          if (res.data.status != 'success') {
            reject(res.data.message);
            return;
          }
          var successData = {
            userIds: postData.userId,
          }

          commit('PAYMENT_COLLECTION_ADMIN_COLLECT', successData);
          resolve(res.data);
        })
    });
  },
  fetchCollectionApprovalAdminList({
    commit,
    dispatch
  }) {
    Nprogress.start()
    return new Promise((resolve, reject) => {
      axios.post('/payments_collection/collection_admin_approval/true')
        .then(res => {
          Nprogress.done()
          commit('SET_COLLECTION_APPROVAL_ADMIN_LIST', res.data)
          resolve(res.data);
        })
        .catch(error => console.log(error))
    });
  },
  fetchCollectionApprovalAdminTableList({
    commit,
    dispatch
  }, postData) {
    Nprogress.start()
    return new Promise((resolve, reject) => {
      axios.post('/payments_collection/get_all_collection_admin_approvals', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(res => {
          Nprogress.done()
          if (res.data.status == "redirect") {
            router.push("/dashboard");
          } else {
            if (postData.export == true) {
              if (res.data.status != "success") {
                reject(res.data.message);
                return;
              }
              window.open("/backend" + res.data.message, "_blank");
              window.focus();
              return;
            }
            commit('SET_COLLECTION_APPROVAL_ADMIN_TABLE_LIST', res.data)
            resolve(res.data);
          }
        })
        .catch(error => console.log(error))
    });
  },
  fetchBuildingMasterList({
    commit,
    dispatch
  }) {
    Nprogress.start()
    return new Promise((resolve, reject) => {
      axios.post('/payments_collection/building_master/true')
        .then(res => {
          Nprogress.done()
          commit('SET_BUILDING_MASTER_LIST', res.data)
          resolve(res.data);
        })
        .catch(error => console.log(error))
    });
  },
  getStreetsForBuildingMaster({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {

      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/payments_collection/get_streets',qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  fetchDueForRenewalUsers(context) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
          canCancel: false,
      });
    axios.get("/payments_collection/get_all_collection_app_users", {
      })
      .then(response => {
        loader.hide();
        if(response.data.status=="error" && response.data.isDatabaseAccessibleCheck=="yes"){
          resolve(response.data);
          return;
        }
        // console.log(response.data);
        const formsData = {
          collectionUsers: response.data.message,
          requestedUsers: response.data.requestedUsers,
          balancedUsers: response.data.balanceUsers,
          collectionExpiredUsers: response.data.collectionExpiredUsers,
          

        }
        context.commit('SET_PAYMENT_USERS', formsData)
      })
      .catch(error => {
        console.log(error);
      });
    });
  },
  extendPaymentDetailSubmit({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/payments_collection/collection_payment_method', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(res => {
          loader.hide()

          if (res.data.status != 'success') {
            reject(res.data.message);
            return;
          }
          resolve(res.data);
        })
    });
  },
  editcollectionTimeField({
    commit,
    dispatch
}, postData) {
    return new Promise((resolve, reject) => {
        axios
            .post("/payments_collection/editCollectionTimeField", qs.stringify(postData, {
                parseArrays: false
            }))
            .then(response => {
                if (response.data.status != "success") {
                    reject(response.data);
                    return;
                }
                var successData = {
                    data: postData,
                }
                commit("UPDATE_PREFERRED_TIME", successData.data)
                resolve(response.data);
            })
            .catch(error => console.log(error));
    });
},
}

const getters = {
  getPaymentBlockedListGetters: state => {
    return state.paymentBlockedList;
  }, 
  getTdsPaymentsListGetters: state => {
    return state.tdsPaymentsList;
  },
  getPaymentDetailsGetters: state => {
    return state.paymentsDetails;
  },
  getChequePaymentsListGetters: state => {
    return state.chequePaymentsList;
  },
  getProductBasedOnAccountIdGetter: state => {
    return state.productsList;
  },
  getCashPaymentsListGetters: state => {
    return state.cashPaymentsDetails;
  },
  BankDepositDetailsGetter: state => {
    return state.bankDepositDetails;
  },
  PaymentCollectionDetailsGetter: state => {
    return state.paymentCollectionDetails;
  },
  getAdminLedgerListGetters: state => {
    return state.adminLedgerDetails;
  },
  getPaymentCollectionListGetters: state => {
    return state.PaymentCollectionUserList;
  },
  PaymentConfigurationGetters: state => {
    return state.paymentCofigurationDetails;
  },
  getCollectionUserAreaListGetters: state => {
    return state.collectionUserAreaDetails;
  },
  getCollectionUserAreaTableListGetters: state => {
    return state.collectionUserAreaTableDetails;
  },
  getCollectionApprovalAreaListGetters: state => {
    return state.collectionApprovalAreaDetails;
  },
  getCollectionApprovalAreaTableListGetters: state => {
    return state.collectionApprovalAreaTableDetails;
  }, 
  CollectionAreaGetters: state => {
    return state.collectionAreaDetails;
  },
  getsampleAreaSampleFilePath: state => {
    return state.areaSampleFilePath;
  },
  getCollectionUserAdminListGetters: state => {
    return state.collectionUserAdminDetails;
  }, 
  getCollectionUserAdminTableListGetters: state => {
    return state.collectionUserAdminTableDetails;
  },
  getCollectionApprovalAdminListGetters: state => {
    return state.collectionApprovalAdminDetails;
  },
  getCollectionApprovalAdminTableListGetters: state => {
    return state.collectionApprovalAdminTableDetails;
  },
  BuildingMasterGetters: state => {
    return state.buildingMasterDetails;
  },
  getCollectionUsersGetter: state => {
    return state.collectionUsers
  },
  getRequestedUsersGetter: state => {
    return state.requestedUsers
  },
  getCollectionExpiredUsersGetter: state => {
    return state.collectionExpiredUsers
  },
  getBalancedUsersGetter: state => {
    return state.balancedUsers
  },

}

export default {
  state,
  mutations,
  actions,
  getters
}